import API from "@aws-amplify/api";
import { useContext, useEffect, useState } from "react";
import { ApiName, RedminePath } from "../actions";
import AppContext from "../contexts/AppContext";

export const useIssueStatuses = () => {
  const { state } = useContext(AppContext);
  const [issueStatuses, setIssueStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const getIssueStatuses = async ({ redmineurl, apikey }) => {
    setLoading(true);
    setErrors({});
    try {
      if (loading !== true) setLoading(true);

      if (apikey && redmineurl) {
        const myInit = {
          headers: { "Content-type": "application/json", "X-Api-Key": apikey },
          queryStringParameters: {
            path: "issue_statuses.json",
            url: redmineurl,
          },
        };
        API.get(ApiName, RedminePath, myInit)
          .then((res) => {
            setIssueStatuses(res.success.issue_statuses);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrors({ api: err });
          });
        return "success";
      }
    } catch (err) {
      console.log("error");
      setErrors({ function: err });
    }
    setLoading(false);
  };

  return {
    getIssueStatuses,
    issueStatuses,
    loading,
    errors,
  };
};
